import Table from 'react-bootstrap/Table';
import {useTranslation} from "react-i18next";
import { XLg } from 'react-bootstrap-icons';
import PlayerNameWithFlag from "../PlayerNameWithFlag";
import {useState, type DragEvent} from "react";
import type {Player} from "../../../types/domain";

interface PlayerSeedingEditableTableProps {
  players: Player[];
  updateSeeding: (fromIndex: number, toIndex: number) => void;
  removePlayer: (index: number) => void;
}

function PlayerSeedingEditableTable(props: PlayerSeedingEditableTableProps) {
  const { t } = useTranslation();

  const [ draggedIndex, setDraggedIndex ] = useState<number | null>(null)
  const [ draggedOverIndex, setDraggedOverIndex ] = useState<number | null>(null)

  const handleDragStart = (e: DragEvent<HTMLTableRowElement>, rowIndex: number) => {
    setDraggedIndex(rowIndex)
    e.dataTransfer.effectAllowed = "move";
  }

  const handleDrop = (e: DragEvent<HTMLTableRowElement>, newIndex: number) => {
    e.preventDefault();
    setDraggedIndex(null)
    setDraggedOverIndex(null)
    if (draggedIndex !== null && draggedIndex !== newIndex) {
      props.updateSeeding(draggedIndex, newIndex)
    }
  }

  const handleDragOver = (e: DragEvent<HTMLTableRowElement>, index: number) => {
    e.preventDefault()
    setDraggedOverIndex(index)
    e.dataTransfer.dropEffect = "move"
  }

  const handleDragEnd = (e: DragEvent<HTMLTableRowElement>) => {
    e.preventDefault()
    setDraggedIndex(null)
    setDraggedOverIndex(null)
  }

  const getRowClass = (index: number) => {
    if (index === draggedIndex) {
      return "table-success"
    } else if (index === draggedOverIndex) {
      return "table-secondary"
    } else {
      return ""
    }
  }

    return (
        <Table striped bordered hover size="sm" variant="dark">
            <thead style={{"textTransform": "none"}}>
            <tr>
              <th className="text-center">#</th>
              <th>{t("player")}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {props.players.map((player, index) => {
                return (
                  <tr key={player.id} draggable style={{cursor: "grab"}}
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragOver={(e) => handleDragOver(e, index)}
                      onDrop={(e) => handleDrop(e, index)}
                      onDragEnd={(e) => handleDragEnd(e)}
                      className={getRowClass(index)}
                  >
                    <th className="text-center">{index + 1}.</th>
                    <th><PlayerNameWithFlag player={player} includeElo={true} /></th>
                    <th className="text-center clickable" onClick={() => props.removePlayer(index)}>
                      <XLg color="red" size={20} />
                    </th>
                  </tr>
                )
            })}
            </tbody>
        </Table>
    );
}

export default PlayerSeedingEditableTable
